export default __webpack_public_path__ + "static/media/clint-mckoy.b76340fe.jpg";